module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('el-col', {
    staticClass: "page-bar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "total-results"
  }, [_vm._v(" " + _vm._s(_vm.totalResult) + " ")])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "empty-text": "暫無資料"
    },
    on: {
      "row-click": _vm.rowClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "15%",
      "prop": "date",
      "label": "申請日期",
      "formatter": _vm.formatDate
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "15%",
      "prop": "name",
      "label": "申請人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "15%",
      "prop": "id",
      "label": "工號"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "20%",
      "prop": "dep",
      "label": "部門"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "15%",
      "prop": "level",
      "label": "師級",
      "formatter": _vm.formatLevel
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "20%",
      "prop": "email",
      "label": "信箱"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "註冊審核",
      "visible": _vm.dialogFormVisible,
      "custom-class": "regApprovalDialog"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialogRow"
  }, [_c('div', {
    staticClass: "dialogCell1"
  }, [_vm._v("申請人")]), _vm._v(" "), _c('div', {
    staticClass: "dialogCell2"
  }, [_vm._v(" " + _vm._s(_vm.dialogData.name) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialogRow"
  }, [_c('div', {
    staticClass: "dialogCell1"
  }, [_vm._v("工號")]), _vm._v(" "), _c('div', {
    staticClass: "dialogCell2"
  }, [_vm._v(" " + _vm._s(_vm.dialogData.id) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialogRow"
  }, [_c('div', {
    staticClass: "dialogCell1"
  }, [_vm._v("部門")]), _vm._v(" "), _c('div', {
    staticClass: "dialogCell2"
  }, [_vm._v(" " + _vm._s(_vm.dialogData.dep) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialogRow"
  }, [_c('div', {
    staticClass: "dialogCell1"
  }, [_vm._v("信箱")]), _vm._v(" "), _c('div', {
    staticClass: "dialogCell2"
  }, [_vm._v(" " + _vm._s(_vm.dialogData.email) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialogRow"
  }, [_c('div', {
    staticClass: "dialogCell1"
  }, [_vm._v("師級")]), _vm._v(" "), _c('div', {
    staticClass: "dialogCell2"
  }, [_vm._v(" " + _vm._s(_vm.formatLevel(_vm.dialogData)) + " ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "rejectBtn",
    on: {
      "click": function($event) {
        return _vm.regApproval(0)
      }
    }
  }, [_vm._v("拒絕")]), _vm._v(" "), _c('el-button', {
    staticClass: "ApprovalBtn",
    on: {
      "click": function($event) {
        return _vm.regApproval(1)
      }
    }
  }, [_vm._v("通過")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07fbac26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/RegApproval.vue
// module id = 891
// module chunks = 170